import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, inject, OnDestroy } from '@angular/core';
import { finalize, takeUntil } from 'rxjs/operators';
import { AuthService } from '../../../auth/auth.service';
import { TieService } from '../../../_core/services/tie.service';
import { ToastService } from '../../../_core/services/toast.service';
import { Subject } from 'rxjs';
import { Capacitor } from '@capacitor/core';
// import { PushNotifications } from '@capacitor/push-notifications';

@Component({
    selector: 'app-follow-tie',
    templateUrl: './follow-tie.component.html',
    styleUrls: ['./follow-tie.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class FollowTieComponent implements OnDestroy {
    private authService = inject(AuthService);
    private tieService = inject(TieService);
    private toast = inject(ToastService);
    private cdr = inject(ChangeDetectorRef);

    @Input({ required: true }) _tieId: string;
    @Input({ required: true }) tieViewers: string[] = [];
    @Input() teamViewers: string[];

    isLoadingFollow: boolean;
    private destroyed$: Subject<void> = new Subject();

    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }

    isViewer(): boolean {
        return this.tieViewers?.includes(this.authService.authUserSignal()?._id)
    }

    unfollow() {
        this.isLoadingFollow = true;
        this.tieService.unfollow(this._tieId)
            .pipe(
                finalize(() => {
                    this.isLoadingFollow = false;
                    this.cdr.detectChanges();
                }
                ),
                takeUntil(this.destroyed$)
            )
            .subscribe({
                next: async res => {
                    this.tieViewers = this.tieViewers?.filter(viewer => viewer !== this.authService.authUserSignal()._id);
                    this.tieService.publishUnfollow(this._tieId);
                }
            }
        );
    }

    async follow() {
        this.isLoadingFollow = true;

        // if (Capacitor.isNativePlatform()) {
        //     let permStatus = await PushNotifications.checkPermissions();

        //     if (permStatus.receive === 'prompt') {
        //       permStatus = await PushNotifications.requestPermissions();
        //     } else if  (permStatus.receive === 'denied') {
        //         alert('To use this functionality you must turn on push notifications in your phone settings');
        //         return;
        //     }
        // }

        this.tieService.follow(this._tieId)
            .pipe(finalize(() => {
                this.isLoadingFollow = false;
                this.cdr.detectChanges();
            }))
            .subscribe({
                next: (res: any) => {
                    if (!this.tieViewers) this.tieViewers = [];
                    this.tieViewers.push(this.authService.authUserSignal()._id);
                    this.tieService.publishFollow(this._tieId);
                }
            });
    }

}
